<template>
    <!-- USPS mobile -->
    <div class="relative w-full">
        <TransitionGroup name="fade-out">
            <div
                v-for="(usp, index) in usps"
                :key="usp.text"
                v-show="currentUspIndex === index"
                class="bg-white py-2 px-4 text-center text-sm"
            >
                <div v-if="currentUspIndex === index">
                    <span v-if="index == 1" class="flex items-center justify-center">
                        <KiyohLogo :class="['h-5 w-5']" />
                        <div class="text-xs text-dgreen2 mr-2">
                            <fa :icon="['fas', 'star']" class="h-3" />
                            <fa :icon="['fas', 'star']" class="h-3" />
                            <fa :icon="['fas', 'star']" class="h-3" />
                            <fa :icon="['fas', 'star']" class="h-3" />
                            <fa :icon="['fas', 'star-half']" class="h-3" />
                        </div>
                        <span v-html="usp.text"></span>
                    </span>
                    <div v-else>
                        <fa :icon="['fal', 'check']" class="text-green-600 mr-2 w-4 inline-block" />
                        <span v-html="usp.text"></span>
                    </div>
                </div>
            </div>
        </TransitionGroup>
    </div>
</template>

<script setup>
import KiyohLogo from '@/Blocks/KiyohLogo.vue';
import { useAppStore } from '@/stores/appStore.js';
import { onBeforeUnmount, onMounted, ref } from 'vue';

const appStore = useAppStore();

const usps = [
    { text: `Voor <strong>23:59</strong> besteld, morgen gratis in huis!` },
    { text: `<strong>${appStore.kiyoh.score}</strong> (${appStore.kiyoh.reviews} beoordelingen)` },
    { text: `Vakkundig advies van <strong>experts</strong>` },
];

const currentUspIndex = ref(0);
const uspInterval = ref(null);

onMounted(() => {
    startUspCycle();
});

onBeforeUnmount(() => {
    stopUspCycle();
});

const startUspCycle = () => {
    uspInterval.value = setInterval(() => {
        currentUspIndex.value = (currentUspIndex.value + 1) % usps.length;
    }, 5000);
};

const stopUspCycle = () => {
    if (uspInterval.value) {
        clearInterval(uspInterval.value);
    }
};
</script>